/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DataUploadIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Data Upload',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18,4.25c0-2.13379-4.02441-3.25-8-3.25S2,2.11621,2,4.25c0,.06714.01538.13037.02325.19556-.00629.03906-.02325.07422-.02325.11499v9.93945c0,1.79492,2.98096,2.50684,4.75781,2.77246.0376.00488.0752.00781.11182.00781.36523,0,.68555-.26758.74072-.63965.06104-.40918-.22119-.79102-.63086-.85254-2.52148-.37598-3.43311-1.08008-3.47949-1.28809v-3.15491c.2533.1283.53253.25378.87354.37073.08105.02832.16309.04102.24365.04102.31152,0,.60254-.19531.70947-.50684.13428-.3916-.07422-.81836-.46582-.95215-1.06494-.36621-1.34473-.72656-1.36084-.79785v-3.27551c1.52985.84216,4.02393,1.27551,6.5,1.27551s4.97015-.43335,6.50006-1.27563l.00018,3.27026c-.01843.08081-.3139.45508-1.43433.82764-.39307.13086-.60596.55566-.47559.94824.10449.31445.39746.51367.71191.51367.07812,0,.15771-.01172.23633-.03809.37933-.12598.68652-.26221.96173-.40186l.00018,3.1499c-.04736.21777-.9751.93164-3.54541,1.30371-.41016.05957-.69434.43945-.63477.84961.0542.37402.37451.64258.74121.64258.03564,0,.07227-.00293.1084-.00781,1.8042-.26172,4.83008-.9707,4.83008-2.78223V4.56055c0-.04077-.01697-.07593-.02325-.11499.00787-.06519.02325-.12842.02325-.19556ZM10,6c-4.28857,0-6.5-1.22656-6.5-1.75s2.21143-1.75,6.5-1.75,6.5,1.22656,6.5,1.75-2.21143,1.75-6.5,1.75Z"
      fill="currentColor"
    />
    <path
      d="M12.4751,13.48242c.19189,0,.38379-.07324.53027-.21973.29297-.29297.29297-.76758,0-1.06055l-2.4751-2.47461c-.29297-.29297-.76758-.29297-1.06055,0l-2.4751,2.47461c-.29297.29297-.29297.76758,0,1.06055s.76758.29297,1.06055,0l1.19482-1.19458v6.67407c0,.41406.33594.75.75.75s.75-.33594.75-.75v-6.67407l1.19482,1.19458c.14648.14648.33838.21973.53027.21973Z"
      fill="currentColor"
    />
  </svg>`;
};
